import React, { useState } from 'react'

const UnitSelectionContext = React.createContext(null)

const UnitSelectionProvider = ({ children }) => {
  const [visibleUnitSelection, setVisibleUnitSelection] = useState(false)

  const [selectedUnits, setSelectedUnits] = useState([])
  return (
    <UnitSelectionContext.Provider
      value={{
        visibleUnitSelection,
        setVisibleUnitSelection,
        selectedUnits,
        setSelectedUnits,
      }}
    >
      {children}
    </UnitSelectionContext.Provider>
  )
}

export { UnitSelectionContext }
export default UnitSelectionProvider
